
import { useEffect, useState } from "react"

import { useDispatch } from "react-redux"

import { Grid, Card, CardHeader, Typography, Divider, CardContent, TextField, FormControl, InputLabel, Select, MenuItem, Button, Stack, Box, Chip, Dialog, DialogTitle, DialogContentText, DialogContent, DialogActions } from "@mui/material"

import moment from "moment"

import { formatCurrency } from "../../../helpers/FormatCurrency"

import { openSnackbar } from "../../../store/slices/SnackbarSlice"

import { Layout } from "../../../components/Layout"

import { ObtenerMateria } from "../../../connections/catalogos/MateriaConnection"
import { ObtenerAutoridadesMaterias } from "../../../connections/catalogos/AutoridadConnection"
import { ObtenerTipoConsecutivo } from "../../../connections/catalogos/TipoConsecutivoConnection"
import { BuscarAmparo, GenerarCaratulaAmparo, EliminarCaratulaAmparo } from "../../../connections/recepcion/AmparoConnection"
import { BuscarIrregular, GenerarCaratulaIrregular, EliminarCaratulaIrregular } from "../../../connections/recepcion/IrregularConnection"
import { BuscarExpediente, GenerarCaratulaExpediente, EliminarCaratulaExpediente } from "../../../connections/recepcion/ExpedienteConnection"
import { BuscarExhortoRecibido, GenerarCaratulaExhorto, EliminarCaratulaExhorto } from "../../../connections/recepcion/ExhortoRecibidoConnection"

import { MateriaProps } from "../../../interfaces/catalogos/MateriaInterface"
import { AutoridadProps } from "../../../interfaces/catalogos/AutoridadInterface"
import { TipoConsecutivoProps } from "../../../interfaces/catalogos/TipoConsecutivoInterface"
import { defaultBuscarAmparo, AmparoProps, defaultAmparo } from "../../../interfaces/recepcion/AmparoInterface"
import { defaultIrregular, defaultIrregularResponse, IrregularProps } from "../../../interfaces/recepcion/IrregularInterface"
import { defaultExpediente, defaultExpedienteResponse, ExpedienteProps } from "../../../interfaces/recepcion/ExpedienteInterface"
import { defaultExhortoRecibido, defaultExhortoRecibidoResponse, ExhortoRecibidoProps } from "../../../interfaces/recepcion/ExhortoRecibidoInterface"

interface CaratulaCardProps {
    caratula:           string;
    iframeTitle:        string;
    disabledGenerar:    boolean;
    onGenerarClick:     () => void;
    onEliminarClick:    () => void;
}

interface ConfirmDialogProps {
    open:       boolean;
    loading:    boolean;
    message:    string;
    onClose:    () => void;
    onConfirm:  () => void;
}

const CaratulaCard = ({ caratula, iframeTitle, disabledGenerar, onGenerarClick, onEliminarClick }: CaratulaCardProps) => {

    return (
        <Card>

            <CardHeader
                sx={{
                    backgroundColor: (theme) => theme.palette.primary.main,
                    py: 2,
                    '& .MuiCardHeader-action': { alignSelf: 'center', margin: 0 },
                }}
                subheader={ <Typography variant='subtitle1' fontWeight={ 500 } sx={{ color: 'white' }}> Carátula </Typography> }
                action={
                    caratula
                    &&
                        <Button color='error' variant='contained' size='small'
                            onClick={ onEliminarClick }>
                            Eliminar carátula
                        </Button>
                }
            />

            <CardContent>

                {
                    caratula
                    ?
                        <iframe
                            title={ iframeTitle }
                            style={{ width: '100%', height: 500, borderRadius: 8, border: 'none' }}
                            src={ caratula }
                        />
                    :
                        <Grid container height={ 500 } alignItems='center' justifyContent='center'>

                            <Button color='primary' variant='contained'
                                disabled={ disabledGenerar }
                                onClick={ onGenerarClick }>
                                Generar carátula
                            </Button>

                        </Grid>
                }

            </CardContent>

        </Card>
    );

}

const ConfirmDialog = ({ open, loading, message, onClose, onConfirm }: ConfirmDialogProps) => {

    return (
        <Dialog fullWidth maxWidth='xs' open={ open } onClose={ () => {} }>

            <DialogTitle>Confirmación</DialogTitle>

            <DialogContent>
                <DialogContentText>{ message }</DialogContentText>
            </DialogContent>

            <DialogActions>
                <Button color='secondary' onClick={ onClose } disabled={ loading }>Cancelar</Button>
                <Button variant='contained' color='primary' loading={ loading } disabled={ loading } onClick={ onConfirm }>Aceptar</Button>
            </DialogActions>

        </Dialog>
    );

}

export const GenerarCaratulaPage = () => {

    const dispatch = useDispatch();

    const [filtroAplicado, setFiltroAplicado] = useState( false );

    const [tipoConsecutivo, setTipoConsecutivo] = useState( 0 );
    const [tipoConsecutivoArray, setTipoConsecutivoArray] = useState<TipoConsecutivoProps[]>( [] );

    const [autoridad, setAutoridad] = useState( 0 );
    const [autoridadArray, setAutoridadArray] = useState<AutoridadProps[]>( [] );

    const [materia, setMateria] = useState( 0 );
    const [materiaArray, setMateriaArray] = useState<MateriaProps[]>( [] );

    const [expediente, setExpediente] = useState<ExpedienteProps>( defaultExpediente );
    const [numeroExpediente, setNumeroExpediente] = useState( '' );

    const [numeroExhorto, setNumeroExhorto] = useState( '' );
    const [exhorto, setExhorto] = useState<ExhortoRecibidoProps>( defaultExhortoRecibido );

    const [numeroIrregular, setNumeroIrregular] = useState( '' );
    const [irregular, setIrregular] = useState<IrregularProps>( defaultIrregular );

    const [numeroAmparo, setNumeroAmparo] = useState( '' );
    const [amparo, setAmparo] = useState<AmparoProps>( defaultAmparo );

    const [loading, setLoading] = useState( false );
    const [loadingCaratula, setLoadingCaratula] = useState( false );
    const [loadingGenerar, setLoadingGenerar] = useState( false );
    const [openConfirmacion, setOpenConfirmacion] = useState( false );
    const [openConfirmarGenerar, setOpenConfirmarGenerar] = useState( false );

    const [loadingExhorto, setLoadingExhorto] = useState( false );
    const [loadingCaratulaExhorto, setLoadingCaratulaExhorto] = useState( false );
    const [loadingGenerarExhorto, setLoadingGenerarExhorto] = useState( false );
    const [openConfirmacionExhorto, setOpenConfirmacionExhorto] = useState( false );
    const [openConfirmarGenerarExhorto, setOpenConfirmarGenerarExhorto] = useState( false );

    const [loadingIrregular, setLoadingIrregular] = useState( false );
    const [loadingCaratulaIrregular, setLoadingCaratulaIrregular] = useState( false );
    const [loadingGenerarIrregular, setLoadingGenerarIrregular] = useState( false );
    const [openConfirmacionIrregular, setOpenConfirmacionIrregular] = useState( false );
    const [openConfirmarGenerarIrregular, setOpenConfirmarGenerarIrregular] = useState( false );

    const [loadingAmparo, setLoadingAmparo] = useState( false );
    const [loadingCaratulaAmparo, setLoadingCaratulaAmparo] = useState( false );
    const [loadingGenerarAmparo, setLoadingGenerarAmparo] = useState( false );
    const [openConfirmacionAmparo, setOpenConfirmacionAmparo] = useState( false );
    const [openConfirmarGenerarAmparo, setOpenConfirmarGenerarAmparo] = useState( false );

    const handleClearFiltros = () => {

        setNumeroExpediente( '' );
        setMateria( 0 );
        setAutoridad( 0 );
        setTipoConsecutivo( 0 );

    }

    const handleClear = () => {

        handleClearFiltros();

        setExpediente( defaultExpedienteResponse );
        setExhorto( defaultExhortoRecibidoResponse );
        setIrregular( defaultIrregularResponse );
        setAmparo( defaultBuscarAmparo );

        setFiltroAplicado( false );

    }

    const handleBuscarExpediente = async () => {

        setLoading( true );

        await BuscarExpediente({ numeroExpediente, idAutoridad: autoridad }).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    setFiltroAplicado( true );
                    setExpediente( resp );

                }
                else {

                    handleClear();
                    dispatch( openSnackbar({ message, variant: 'error' }) );

                }

                setLoading( false );

            }, 700);

        });

    }

    const handleGenerarCaratulaExpediente = async () => {

        setLoadingCaratula( true );

        await GenerarCaratulaExpediente( expediente.idExpediente ).then( resp => {

            setTimeout(() => {

                const { success, message, caratula } = resp;

                if ( success && caratula ) {

                    setExpediente( prev => ({ ...prev, caratula }) );
                    setOpenConfirmarGenerar( false );

                }
                else {

                    dispatch( openSnackbar({ message, variant: 'error' }) );
                    setOpenConfirmarGenerar( false );

                }

                setLoadingCaratula( false );

            }, 700);

        });

    }

    const handleEliminarCaratulaExpediente = async () => {

        setLoadingGenerar( true );

        await EliminarCaratulaExpediente( expediente.idExpediente ).then( resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    setExpediente( prev => ({ ...prev, caratula: '' }) );
                    setOpenConfirmacion( false );

                }
                else {

                    dispatch( openSnackbar({ message, variant: 'error' }) );
                    setOpenConfirmacion( false );

                }

                setLoadingGenerar( false );

            }, 700);

        });
    }

    const handleBuscarExhorto = async () => {

        setLoadingExhorto( true );

        await BuscarExhortoRecibido({ numeroExhortoRecibido: numeroExhorto, idAutoridad: autoridad }).then( resp => {

            setTimeout(() => {

                if ( resp.success ) {

                    setFiltroAplicado( true );
                    setExhorto( resp );

                }
                else {

                    handleClear();
                    dispatch( openSnackbar({ message: resp.message, variant: 'error' }) );

                }

                setLoadingExhorto( false );

            }, 700);

        });

    }

    const handleGenerarCaratulaExhorto = async () => {

        setLoadingCaratulaExhorto( true );

        await GenerarCaratulaExhorto( exhorto.idExhortoRecibido ).then( resp => {

            setTimeout(() => {

                if ( resp.success && resp.caratula ) {

                    setExhorto( prev => ({ ...prev, caratula: resp.caratula ?? '' }) );
                    setOpenConfirmarGenerarExhorto( false );

                }
                else {

                    dispatch( openSnackbar({ message: resp.message, variant: 'error' }) );
                    setOpenConfirmarGenerarExhorto( false );

                }

                setLoadingCaratulaExhorto( false );

            }, 700);

        });
    }

    const handleEliminarCaratulaExhorto = async () => {

        setLoadingGenerarExhorto( true );

        await EliminarCaratulaExhorto( exhorto.idExhortoRecibido ).then( resp => {

            setTimeout(() => {

                if ( resp.success ) {

                    setExhorto( prev => ({ ...prev, caratula: '' }) );
                    setOpenConfirmacionExhorto( false );

                }
                else {

                    dispatch( openSnackbar({ message: resp.message, variant: 'error' }) );
                    setOpenConfirmacionExhorto( false );

                }

                setLoadingGenerarExhorto( false );

            }, 700);

        });

    }

    const handleBuscarIrregular = async () => {

        setLoadingIrregular( true );

        await BuscarIrregular({ numeroIrregular, idAutoridad: autoridad }).then( resp => {

            setTimeout(() => {

                if ( resp.success ) {

                    setFiltroAplicado( true );
                    setIrregular( resp );

                }
                else {

                    handleClear();
                    dispatch( openSnackbar({ message: resp.message, variant: 'error' }) );

                }

                setLoadingIrregular( false );

            }, 700);

        });

    }

    const handleGenerarCaratulaIrregular = async () => {

        setLoadingCaratulaIrregular( true );

        await GenerarCaratulaIrregular( irregular.idIrregular ).then( resp => {

            setTimeout(() => {

                if ( resp.success && resp.caratula ) {

                    setIrregular( prev => ({ ...prev, caratula: resp.caratula ?? '' }) );
                    setOpenConfirmarGenerarIrregular( false );

                }
                else {

                    dispatch( openSnackbar({ message: resp.message, variant: 'error' }) );
                    setOpenConfirmarGenerarIrregular( false );

                }

                setLoadingCaratulaIrregular( false );

            }, 700);

        });

    }

    const handleEliminarCaratulaIrregular = async () => {

        setLoadingGenerarIrregular( true );

        await EliminarCaratulaIrregular( irregular.idIrregular ).then( resp => {

            setTimeout(() => {

                if ( resp.success ) {

                    setIrregular( prev => ({ ...prev, caratula: '' }) );
                    setOpenConfirmacionIrregular( false );

                }
                else {

                    dispatch( openSnackbar({ message: resp.message, variant: 'error' }) );
                    setOpenConfirmacionIrregular( false );

                }

                setLoadingGenerarIrregular( false );

            }, 700);

        });

    }

    const handleBuscarAmparo = async () => {

        setLoadingAmparo( true );

        await BuscarAmparo({ numeroAmparo, numeroAmparoOrigen: '', numeroExpediente: '', idAutoridad: autoridad }).then( resp => {

            setTimeout(() => {

                if ( resp.length !== 0 ) {

                    setFiltroAplicado( true );
                    setAmparo( resp[0] );

                }
                else {

                    handleClear();
                    dispatch( openSnackbar({ message: 'No se encontró el amparo con los datos proporcionados.', variant: 'error' }) );

                }

                setLoadingAmparo( false );

            }, 700);

        });
    }

    const handleGenerarCaratulaAmparo = async () => {

        setLoadingCaratulaAmparo( true );

        await GenerarCaratulaAmparo( amparo.idAmparo ).then( resp => {

            setTimeout(() => {

                if ( resp.success && resp.caratula ) {

                    setAmparo( prev => ({ ...prev, caratula: resp.caratula ?? '' }) );
                    setOpenConfirmarGenerarAmparo( false );

                }
                else {

                    dispatch( openSnackbar({ message: resp.message, variant: 'error' }) );
                    setOpenConfirmarGenerarAmparo( false );

                }

                setLoadingCaratulaAmparo( false );

            }, 700);

        });

    }

    const handleEliminarCaratulaAmparo = async () => {

        setLoadingGenerarAmparo( true );

        await EliminarCaratulaAmparo( amparo.idAmparo ).then( resp => {

            setTimeout(() => {

                if ( resp.success ) {

                    setAmparo( prev => ({ ...prev, caratula: '' }) );
                    setOpenConfirmacionAmparo( false );

                }
                else {

                    dispatch( openSnackbar({ message: resp.message, variant: 'error' }) );
                    setOpenConfirmacionAmparo( false );

                }

                setLoadingGenerarAmparo( false );

            }, 700);

        });

    }

    useEffect(() => {

        async function Obtener() {

            await ObtenerMateria().then( resp => {
                setMateriaArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            setAutoridad( 0 );
            setAutoridadArray( [] );

            await ObtenerAutoridadesMaterias( materia ).then( resp => {
                setAutoridadArray( resp );
            });

        }

        if ( materia !== 0 ) {
            Obtener();
        }

    }, [ materia ]);

    useEffect(() => {

        async function Obtener() {

            await ObtenerTipoConsecutivo().then( resp => {
                setTipoConsecutivoArray( resp );
            });

        }

        Obtener();

    }, []);

    return (
        <Layout breadcrumbs={ [{ text: 'Tribunal' }, { text: 'Carátula' }, { text: 'Generar carátula' }] } backgroundPaper={ false }>

            <Grid container spacing={ 3 }>

                <Grid size={{ md: 12, xs: 12 }}>

                    <Card>

                        <CardHeader
                            sx={{ backgroundColor: (theme) => theme.palette.primary.main, py: 2 }}
                            subheader={
                                <Typography sx={{ fontSize: 14, fontWeight: 'bold', color: 'white' }}>
                                    Filtro(s)
                                </Typography>
                            }
                        />

                        <Divider />

                        <CardContent sx={{ p: 3 }}>

                            <Grid container spacing={ 3 }>

                                <Grid size={{ md: 3, xs: 12 }}>

                                    <FormControl fullWidth>

                                        <InputLabel>Tipo de consecutivo</InputLabel>
                                        <Select
                                            label='Tipo de consecutivo'
                                            value={ tipoConsecutivo }
                                            onChange={ (e) => setTipoConsecutivo( parseInt( e.target.value.toString() ) ) }
                                            disabled={ filtroAplicado }
                                        >
                                            <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                tipoConsecutivoArray
                                                .filter( (e) => e.idTipoConsecutivo === 1 || e.idTipoConsecutivo === 2 || e.idTipoConsecutivo === 3 || e.idTipoConsecutivo === 6 )
                                                .map( (e) => (
                                                    <MenuItem key={ e.idTipoConsecutivo } value={ e.idTipoConsecutivo }>{ e.descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 2, xs: 12 }}>

                                    <FormControl fullWidth>

                                        <InputLabel>Materia</InputLabel>
                                        <Select
                                            label='Materia'
                                            value={ materia }
                                            onChange={ (e) => setMateria( parseInt( e.target.value.toString() ) ) }
                                            disabled={ filtroAplicado }
                                        >
                                            <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                materiaArray
                                                .filter( (e) => e.idMateria === 5 || e.idMateria === 6 )
                                                .map( (e) => (
                                                    <MenuItem key={ e.idMateria } value={ e.idMateria }>{ e.descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 5, xs: 12 }}>

                                    <FormControl fullWidth>

                                        <InputLabel>Autoridad</InputLabel>
                                        <Select
                                            label='Autoridad'
                                            value={ autoridad }
                                            onChange={ (e) => setAutoridad( parseInt( e.target.value.toString() ) ) }
                                            disabled={ materia === 0 || filtroAplicado }
                                        >
                                            <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                            {
                                                autoridadArray.map( (e) => (
                                                    <MenuItem key={ e.idAutoridad } value={ e.idAutoridad }>{ e.descripcion }</MenuItem>
                                                ))
                                            }
                                        </Select>

                                    </FormControl>

                                </Grid>

                                <Grid size={{ md: 2, xs: 12 }}>

                                    <TextField
                                        fullWidth
                                        label={ 'Número de referencia' }
                                        variant='outlined'
                                        placeholder={ `1/${ new Date().getFullYear() }` }
                                        disabled={ filtroAplicado }
                                        value={
                                            tipoConsecutivo === 1 ? numeroExpediente :
                                                tipoConsecutivo === 2 ? numeroExhorto :
                                                    tipoConsecutivo === 3 ? numeroIrregular :
                                                        tipoConsecutivo === 6 ? numeroAmparo :
                                                            ''
                                        }
                                        onChange={ (e) => {
                                            if ( tipoConsecutivo === 1 ) setNumeroExpediente( e.target.value );
                                            else if ( tipoConsecutivo === 2 ) setNumeroExhorto( e.target.value );
                                            else if ( tipoConsecutivo === 3 ) setNumeroIrregular( e.target.value );
                                            else if ( tipoConsecutivo === 6 ) setNumeroAmparo( e.target.value );
                                        }}
                                        slotProps={{
                                            input: { autoComplete: 'off' },
                                            inputLabel: { shrink: true }
                                        }}
                                    />

                                </Grid>

                                <Grid size={{ md: 8, xs: 6 }}>

                                    <Box>

                                        <Typography variant='subtitle2' color='text.secondary'>
                                            Ingresa un número de referencia para consultar la información y generar la carátula.
                                        </Typography>

                                    </Box>

                                </Grid>

                                <Grid size={{ md: 4, xs: 12 }} textAlign='end'>

                                    <Button
                                        sx={{ width: { md: 220, xs: '100%' } }}
                                        variant={ filtroAplicado ? 'outlined' : 'contained' }
                                        color={ filtroAplicado ? 'secondary' : 'primary' }
                                        onClick={ () =>
                                            filtroAplicado
                                            ?
                                                handleClear()
                                            :

                                                tipoConsecutivo === 1 ? handleBuscarExpediente() :
                                                    tipoConsecutivo === 2 ? handleBuscarExhorto() :
                                                        tipoConsecutivo === 3 ? handleBuscarIrregular() :
                                                            tipoConsecutivo === 6 ? handleBuscarAmparo() :
                                                                {}
                                        }
                                        loading={
                                            tipoConsecutivo === 1 ? loading :
                                                tipoConsecutivo === 2 ? loadingExhorto :
                                                    tipoConsecutivo === 3 ? loadingIrregular :
                                                        tipoConsecutivo === 6 ? loadingAmparo :
                                                            false
                                        }
                                        disabled={
                                            autoridad === 0 || tipoConsecutivo === 0 ||
                                            ( tipoConsecutivo === 1 && ( numeroExpediente === '' || loading ) ) ||
                                            ( tipoConsecutivo === 2 && ( numeroExhorto === '' || loadingExhorto ) ) ||
                                            ( tipoConsecutivo === 3 && ( numeroIrregular === '' || loadingIrregular ) ) ||
                                            ( tipoConsecutivo === 6 && ( numeroAmparo === '' || loadingAmparo ) )
                                        }
                                    >
                                        { filtroAplicado ? 'Limpiar' : 'Buscar' }
                                    </Button>

                                </Grid>

                            </Grid>

                        </CardContent>

                    </Card>

                </Grid>

                {
                    tipoConsecutivo === 1
                    &&
                        <Grid size={{ md: 6, xs: 12 }}>

                            <Card>

                                <CardHeader
                                    sx={{
                                        backgroundColor: (theme) => theme.palette.primary.main,
                                        py: 2,
                                        '& .MuiCardHeader-action': { alignSelf: 'center', margin: 0 },
                                    }}
                                    subheader={ <Typography variant='subtitle1' fontWeight={ 500 } sx={{ color: 'white' }}> Información del expediente </Typography> }
                                />

                                <CardContent>

                                    <Grid container rowSpacing={ 3 } columnSpacing={ 1 }>

                                        <Grid size={{ md: 4, xs: 12 }}>
                                            <Typography variant='subtitle2' color='text.secondary'>
                                                Número de expediente:
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ md: 8, xs: 12 }}>
                                            <Typography variant='subtitle2'>
                                                { expediente.numeroExpediente }
                                                { expediente.numeroFolio && <small style={{ fontSize: 14 }}> (F. { expediente.numeroFolio })</small> }
                                            </Typography>
                                        </Grid>

                                        {
                                            expediente.fecha
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Fecha:
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        <Typography variant='subtitle2'>
                                                            { moment( expediente.fecha ).format( 'DD-MM-YYYY HH:mm a' ) }
                                                        </Typography>
                                                    </Grid>
                                                </>
                                        }

                                        {
                                            expediente.cuantia
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Cuantía:
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        <Typography variant='subtitle2'>
                                                            { formatCurrency( expediente.cuantia ) }
                                                        </Typography>
                                                    </Grid>
                                                </>
                                        }

                                        <Grid size={{ md: 4, xs: 12 }}>
                                            <Typography variant='subtitle2' color='text.secondary'>
                                                Tipo de juicio:
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ md: 8, xs: 12 }}>
                                            <Typography variant='subtitle2'>
                                                { expediente.tipoJuicio }
                                            </Typography>
                                        </Grid>

                                        {
                                            expediente.tipoCalificacion
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Tipo de calificación:
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        <Typography variant='subtitle2'>
                                                            { expediente.tipoCalificacion }
                                                        </Typography>
                                                    </Grid>
                                                </>
                                        }

                                        {
                                            expediente.etapa
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Etapa:
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        <Typography variant='subtitle2'>
                                                            { expediente.subEtapa ? `${ expediente.etapa } (${ expediente.subEtapa })` : expediente.etapa }
                                                        </Typography>
                                                    </Grid>
                                                </>
                                        }

                                        <Grid size={{ md: 4, xs: 12 }}>
                                            <Typography variant='subtitle2' color='text.secondary'>
                                                Juez(a):
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ md: 8, xs: 12 }}>
                                            <Typography variant='subtitle2'>
                                                { expediente.juez }
                                            </Typography>
                                        </Grid>

                                        {
                                            expediente.secretario
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Secretario(a) admisibilidad:
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        <Typography variant='subtitle2'>
                                                            { expediente.secretario }
                                                        </Typography>
                                                    </Grid>
                                                </>
                                        }

                                        {
                                            expediente.secretarioTramite
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Secretario(a) de trámite:
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        <Typography variant='subtitle2'>
                                                            { expediente.secretarioTramite }
                                                        </Typography>
                                                    </Grid>
                                                </>
                                        }

                                        {
                                            expediente.secretarioTramiteMenor
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Secretario(a) de trámite (menor cuantía):
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        <Typography variant='subtitle2'>
                                                            { expediente.secretarioTramiteMenor }
                                                        </Typography>
                                                    </Grid>
                                                </>
                                        }

                                        {
                                            expediente.secretarioEjecucion
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Secretario(a) de ejecución:
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        <Typography variant='subtitle2'>
                                                            { expediente.secretarioEjecucion }
                                                        </Typography>
                                                    </Grid>
                                                </>
                                        }

                                        <Grid size={{ md: 4, xs: 12 }}>
                                            <Typography variant='subtitle2' color='text.secondary'>
                                                Juzgado de origen:
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ md: 8, xs: 12 }}>
                                            <Typography variant='subtitle2'>
                                                { expediente.juzgadoOrigen }
                                            </Typography>
                                        </Grid>

                                        {
                                            expediente.actores.length !== 0
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Actor(es):
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        {
                                                            expediente.actores.map( (actor, index) => (
                                                                <Typography key={ index } variant='subtitle2'>
                                                                    { actor }
                                                                </Typography>
                                                            ))
                                                        }
                                                    </Grid>
                                                </>
                                        }

                                        {
                                            expediente.demandados.length !== 0
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Demandado(s):
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        {
                                                            expediente.demandados.map( (demandado, index) => (
                                                                <Typography key={ index } variant='subtitle2'>
                                                                    { demandado }
                                                                </Typography>
                                                            ))
                                                        }
                                                    </Grid>
                                                </>
                                        }

                                        {
                                            expediente.prestaciones.length !== 0
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Prestación(es):
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        {
                                                            expediente.prestaciones.map( (prestacion, index) => (
                                                                <Typography key={ index } variant='subtitle2' color='secondary' fontWeight='bold'>
                                                                    { prestacion }
                                                                </Typography>
                                                            ))
                                                        }
                                                    </Grid>
                                                </>
                                        }

                                    </Grid>

                                </CardContent>

                            </Card>

                        </Grid>
                }

                {
                    tipoConsecutivo === 1
                    &&
                        <Grid size={{ md: 6, xs: 12 }}>

                            <CaratulaCard
                                caratula={ expediente.caratula }
                                iframeTitle='iframe-documento'
                                disabledGenerar={ expediente.idExpediente === 0 }
                                onGenerarClick={ () => setOpenConfirmarGenerar( true ) }
                                onEliminarClick={ () => setOpenConfirmacion( true ) }
                            />

                        </Grid>
                }

                {
                    tipoConsecutivo === 2
                    &&
                        <Grid size={{ md: 6, xs: 12 }}>

                            <Card>

                                <CardHeader
                                    sx={{
                                        backgroundColor: (theme) => theme.palette.primary.main,
                                        py: 2,
                                        '& .MuiCardHeader-action': { alignSelf: 'center', margin: 0 },
                                    }}
                                    subheader={ <Typography variant='subtitle1' fontWeight={ 500 } sx={{ color: 'white' }}> Información del exhorto </Typography> }
                                />

                                <CardContent>

                                    <Grid container rowSpacing={ 3 } columnSpacing={ 1 }>

                                        <Grid size={{ md: 4, xs: 12 }}>
                                            <Typography variant='subtitle2' color='text.secondary'>
                                                Número de exhorto:
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ md: 8, xs: 12 }}>
                                            <Typography variant='subtitle2'>
                                                { exhorto.numeroExhorto }
                                                { exhorto.numeroFolio && <small style={{ fontSize: 14 }}> (F. { exhorto.numeroFolio })</small> }
                                            </Typography>
                                        </Grid>

                                        {
                                            exhorto.numeroExpedienteOrigen
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Expediente de origen:
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        <Typography variant='subtitle2'>
                                                            { exhorto.numeroExpedienteOrigen }
                                                        </Typography>
                                                    </Grid>
                                                </>
                                        }

                                        {
                                            exhorto.fecha
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Fecha:
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        <Typography variant='subtitle2'>
                                                            { moment( exhorto.fecha ).format( 'DD-MM-YYYY HH:mm a' ) }
                                                        </Typography>
                                                    </Grid>
                                                </>
                                        }

                                        {
                                            exhorto.cuantia
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Cuantía:
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        <Typography variant='subtitle2'>
                                                            { formatCurrency( exhorto.cuantia ) }
                                                        </Typography>
                                                    </Grid>
                                                </>
                                        }

                                        <Grid size={{ md: 4, xs: 12 }}>
                                            <Typography variant='subtitle2' color='text.secondary'>
                                                Tipo de juicio:
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ md: 8, xs: 12 }}>
                                            <Typography variant='subtitle2'>
                                                { exhorto.tipoJuicio }
                                            </Typography>
                                        </Grid>

                                        {
                                            exhorto.etapa
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Etapa:
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        <Typography variant='subtitle2'>
                                                            { exhorto.subEtapa ? `${ exhorto.etapa } (${ exhorto.subEtapa })` : exhorto.etapa }
                                                        </Typography>
                                                    </Grid>
                                                </>
                                        }

                                        <Grid size={{ md: 4, xs: 12 }}>
                                            <Typography variant='subtitle2' color='text.secondary'>
                                                Juez(a):
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ md: 8, xs: 12 }}>
                                            <Typography variant='subtitle2'>
                                                { exhorto.juez }
                                            </Typography>
                                        </Grid>

                                        {
                                            exhorto.secretario
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Secretario(a) de trámite:
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        <Typography variant='subtitle2'>
                                                            { exhorto.secretario }
                                                        </Typography>
                                                    </Grid>
                                                </>
                                        }

                                        <Grid size={{ md: 4, xs: 12 }}>
                                            <Typography variant='subtitle2' color='text.secondary'>
                                                Clase de exhorto:
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ md: 8, xs: 12 }}>
                                            <Typography variant='subtitle2'>
                                                { exhorto.claseExhorto }
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ md: 4, xs: 12 }}>
                                            <Typography variant='subtitle2' color='text.secondary'>
                                                Objeto del exhorto:
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ md: 8, xs: 12 }}>
                                            <Typography variant='subtitle2'>
                                                { exhorto.objetoExhorto }
                                            </Typography>
                                        </Grid>

                                        {
                                            exhorto.autoridadExhortoRecibido
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Autoridad del exhorto:
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        <Typography variant='subtitle2'>
                                                            { exhorto.autoridadExhortoRecibido }
                                                        </Typography>
                                                    </Grid>
                                                </>
                                        }

                                        <Grid size={{ md: 4, xs: 12 }}>
                                            <Typography variant='subtitle2' color='text.secondary'>
                                                Juzgado de origen:
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ md: 8, xs: 12 }}>
                                            <Typography variant='subtitle2'>
                                                { exhorto.juzgadoOrigen }
                                            </Typography>
                                        </Grid>

                                        {
                                            exhorto.actores.length !== 0
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Actor(es):
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        {
                                                            exhorto.actores.map( (actor, index) => (
                                                                <Typography key={ index } variant='subtitle2'>
                                                                    { actor }
                                                                </Typography>
                                                            ))
                                                        }
                                                    </Grid>
                                                </>
                                        }

                                        {
                                            exhorto.demandados.length !== 0
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Demandado(s):
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        {
                                                            exhorto.demandados.map( (demandado, index) => (
                                                                <Typography key={ index } variant='subtitle2'>
                                                                    { demandado }
                                                                </Typography>
                                                            ))
                                                        }
                                                    </Grid>
                                                </>
                                        }

                                    </Grid>

                                </CardContent>

                            </Card>

                        </Grid>
                }

                {
                    tipoConsecutivo === 2
                    &&
                        <Grid size={{ md: 6, xs: 12 }}>

                            <CaratulaCard
                                caratula={ exhorto.caratula }
                                iframeTitle='iframe-exhorto'
                                disabledGenerar={ exhorto.idExhortoRecibido === 0 }
                                onGenerarClick={ () => setOpenConfirmarGenerarExhorto( true ) }
                                onEliminarClick={ () => setOpenConfirmacionExhorto( true ) }
                            />

                        </Grid>
                }

                {
                    tipoConsecutivo === 3
                    &&
                        <Grid size={{ md: 6, xs: 12 }}>

                            <Card>

                                <CardHeader
                                    sx={{
                                        backgroundColor: (theme) => theme.palette.primary.main,
                                        py: 2,
                                        '& .MuiCardHeader-action': { alignSelf: 'center', margin: 0 },
                                    }}
                                    subheader={ <Typography variant='subtitle1' fontWeight={ 500 } sx={{ color: 'white' }}> Información del irregular </Typography> }
                                />

                                <CardContent>

                                    <Grid container rowSpacing={ 3 } columnSpacing={ 1 }>

                                        <Grid size={{ md: 4, xs: 12 }}>
                                            <Typography variant='subtitle2' color='text.secondary'>
                                                Número de irregular:
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ md: 8, xs: 12 }}>
                                            <Typography variant='subtitle2'>
                                                { irregular.numeroIrregular }
                                            </Typography>
                                        </Grid>

                                        {
                                            irregular.numeroExpediente
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Número de expediente:
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        <Typography variant='subtitle2'>
                                                            { irregular.numeroExpediente }
                                                        </Typography>
                                                    </Grid>
                                                </>
                                        }

                                        {
                                            irregular.fecha
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Fecha:
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        <Typography variant='subtitle2'>
                                                            { moment( irregular.fecha ).format( 'DD-MM-YYYY HH:mm a' ) }
                                                        </Typography>
                                                    </Grid>
                                                </>
                                        }

                                        {
                                            irregular.etapa
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Etapa:
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        <Typography variant='subtitle2'>
                                                            { irregular.subEtapa ? `${ irregular.etapa } (${ irregular.subEtapa })` : irregular.etapa }
                                                        </Typography>
                                                    </Grid>
                                                </>
                                        }

                                        <Grid size={{ md: 4, xs: 12 }}>
                                            <Typography variant='subtitle2' color='text.secondary'>
                                                Juez(a):
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ md: 8, xs: 12 }}>
                                            <Typography variant='subtitle2'>
                                                { irregular.juez }
                                            </Typography>
                                        </Grid>

                                        {
                                            irregular.secretario
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Secretario(a) de trámite:
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        <Typography variant='subtitle2'>
                                                            { irregular.secretario }
                                                        </Typography>
                                                    </Grid>
                                                </>
                                        }

                                        <Grid size={{ md: 4, xs: 12 }}>
                                            <Typography variant='subtitle2' color='text.secondary'>
                                                Juzgado de origen:
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ md: 8, xs: 12 }}>
                                            <Typography variant='subtitle2'>
                                                { irregular.juzgadoOrigen }
                                            </Typography>
                                        </Grid>

                                        {
                                            irregular.actores.length !== 0
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Actor(es):
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        {
                                                            irregular.actores.map( (actor, index) => (
                                                                <Typography key={ index } variant='subtitle2'>
                                                                    { actor }
                                                                </Typography>
                                                            ))
                                                        }
                                                    </Grid>
                                                </>
                                        }

                                        {
                                            irregular.demandados.length !== 0
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Demandado(s):
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        {
                                                            irregular.demandados.map( (demandado, index) => (
                                                                <Typography key={ index } variant='subtitle2'>
                                                                    { demandado }
                                                                </Typography>
                                                            ))
                                                        }
                                                    </Grid>
                                                </>
                                        }

                                    </Grid>

                                </CardContent>

                            </Card>

                        </Grid>
                }

                {
                    tipoConsecutivo === 3
                    &&
                        <Grid size={{ md: 6, xs: 12 }}>

                            <CaratulaCard
                                caratula={ irregular.caratula }
                                iframeTitle='iframe-irregular'
                                disabledGenerar={ irregular.idIrregular === 0 }
                                onGenerarClick={ () => setOpenConfirmarGenerarIrregular( true ) }
                                onEliminarClick={ () => setOpenConfirmacionIrregular( true ) }
                            />

                        </Grid>
                }

                {
                    tipoConsecutivo === 6
                    &&
                        <Grid size={{ md: 6, xs: 12 }}>

                            <Card>

                                <CardHeader
                                    sx={{
                                        backgroundColor: (theme) => theme.palette.primary.main,
                                        py: 2,
                                        '& .MuiCardHeader-action': { alignSelf: 'center', margin: 0 },
                                    }}
                                    subheader={ <Typography variant='subtitle1' fontWeight={ 500 } sx={{ color: 'white' }}> Información del amparo </Typography> }
                                />

                                <CardContent>

                                    <Grid container rowSpacing={ 3 } columnSpacing={ 1 }>

                                        <Grid size={{ md: 4, xs: 12 }}>
                                            <Typography variant='subtitle2' color='text.secondary'>
                                                Número de amparo:
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ md: 8, xs: 12 }}>
                                            <Typography variant='subtitle2'>
                                                { amparo.numeroAmparo }
                                            </Typography>
                                        </Grid>

                                        {
                                            amparo.numeroAmparoOrigen
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Amparo de origen:
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        <Typography variant='subtitle2'>
                                                            { amparo.numeroAmparoOrigen }
                                                        </Typography>
                                                    </Grid>
                                                </>
                                        }

                                        {
                                            amparo.numeroExpediente
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Expediente:
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        <Typography variant='subtitle2'>
                                                            { amparo.numeroExpediente }
                                                        </Typography>
                                                    </Grid>
                                                </>
                                        }

                                        <Grid size={{ md: 4, xs: 12 }}>
                                            <Typography variant='subtitle2' color='text.secondary'>
                                                Tipo de amparo:
                                            </Typography>
                                        </Grid>

                                        <Grid size={{ md: 8, xs: 12 }}>
                                            <Typography variant='subtitle2'>
                                                { amparo.tipoAmparo }
                                            </Typography>
                                        </Grid>

                                        {
                                            amparo.fecha
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Fecha:
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        <Typography variant='subtitle2'>
                                                            { moment( amparo.fecha ).format( 'DD-MM-YYYY HH:mm a' ) }
                                                        </Typography>
                                                    </Grid>
                                                </>
                                        }

                                        {
                                            amparo.autoridadAmparo
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Autoridad del amparo:
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        <Typography variant='subtitle2'>
                                                            { amparo.autoridadAmparo }
                                                        </Typography>
                                                    </Grid>
                                                </>
                                        }

                                        {
                                            amparo.juez
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Juez(a):
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        <Typography variant='subtitle2'>
                                                            { amparo.juez }
                                                        </Typography>
                                                    </Grid>
                                                </>
                                        }

                                        {
                                            amparo.secretario
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Secretario(a):
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        <Typography variant='subtitle2'>
                                                            { amparo.secretario }
                                                        </Typography>
                                                    </Grid>
                                                </>
                                        }

                                        {
                                            amparo.juzgadoOrigen
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Juzgado de origen:
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>
                                                        <Typography variant='subtitle2'>
                                                            { amparo.juzgadoOrigen }
                                                        </Typography>
                                                    </Grid>
                                                </>
                                        }

                                        {
                                            amparo.partes.length !== 0
                                            &&
                                                <>
                                                    <Grid size={{ md: 4, xs: 12 }}>
                                                        <Typography variant='subtitle2' color='text.secondary'>
                                                            Parte(s):
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ md: 8, xs: 12 }}>

                                                        <Stack divider={ <Divider /> } spacing={ 2 }>
                                                            {
                                                                amparo.partes.map( (parte, index) => (
                                                                    <Box
                                                                        key={ index }
                                                                        sx={{
                                                                            display: 'flex',
                                                                            flexDirection: 'column',
                                                                            alignItems: 'flex-start',
                                                                            gap: 0.5,
                                                                        }}
                                                                    >
                                                                        <Typography variant='subtitle2' fontWeight={ 600 }>
                                                                            { parte.persona }
                                                                        </Typography>

                                                                        <Chip
                                                                            label={ parte.tipoParte }
                                                                            size='small'
                                                                            sx={{
                                                                                fontSize: 11,
                                                                                borderRadius: '99px',
                                                                                backgroundColor: 'action.hover',
                                                                                border: '1px solid',
                                                                                borderColor: 'divider',
                                                                            }}
                                                                        />
                                                                    </Box>
                                                                ))
                                                            }
                                                        </Stack>

                                                    </Grid>
                                                </>
                                        }

                                    </Grid>

                                </CardContent>

                            </Card>

                        </Grid>
                }

                {
                    tipoConsecutivo === 6
                    &&
                        <Grid size={{ md: 6, xs: 12 }}>

                            <CaratulaCard
                                caratula={ amparo.caratula }
                                iframeTitle='iframe-amparo'
                                disabledGenerar={ amparo.idAmparo === 0 }
                                onGenerarClick={ () => setOpenConfirmarGenerarAmparo( true ) }
                                onEliminarClick={ () => setOpenConfirmacionAmparo( true ) }
                            />

                        </Grid>
                }

            </Grid>

            <ConfirmDialog
                open={ openConfirmarGenerar }
                loading={ loadingCaratula }
                message='¿Desea generar la carátula?'
                onClose={ () => setOpenConfirmarGenerar( false ) }
                onConfirm={ handleGenerarCaratulaExpediente }
            />

            <ConfirmDialog
                open={ openConfirmacion }
                loading={ loadingGenerar }
                message='¿Desea eliminar la carátula?'
                onClose={ () => setOpenConfirmacion( false ) }
                onConfirm={ handleEliminarCaratulaExpediente }
            />

            <ConfirmDialog
                open={ openConfirmarGenerarExhorto }
                loading={ loadingCaratulaExhorto }
                message='¿Desea generar la carátula?'
                onClose={ () => setOpenConfirmarGenerarExhorto( false ) }
                onConfirm={ handleGenerarCaratulaExhorto }
            />

            <ConfirmDialog
                open={ openConfirmacionExhorto }
                loading={ loadingGenerarExhorto }
                message='¿Desea eliminar la carátula?'
                onClose={ () => setOpenConfirmacionExhorto( false ) }
                onConfirm={ handleEliminarCaratulaExhorto }
            />

            <ConfirmDialog
                open={ openConfirmarGenerarIrregular }
                loading={ loadingCaratulaIrregular }
                message='¿Desea generar la carátula?'
                onClose={ () => setOpenConfirmarGenerarIrregular( false ) }
                onConfirm={ handleGenerarCaratulaIrregular }
            />

            <ConfirmDialog
                open={ openConfirmacionIrregular }
                loading={ loadingGenerarIrregular }
                message='¿Desea eliminar la carátula?'
                onClose={ () => setOpenConfirmacionIrregular( false ) }
                onConfirm={ handleEliminarCaratulaIrregular }
            />

            <ConfirmDialog
                open={ openConfirmarGenerarAmparo }
                loading={ loadingCaratulaAmparo }
                message='¿Desea generar la carátula?'
                onClose={ () => setOpenConfirmarGenerarAmparo( false ) }
                onConfirm={ handleGenerarCaratulaAmparo }
            />

            <ConfirmDialog
                open={ openConfirmacionAmparo }
                loading={ loadingGenerarAmparo }
                message='¿Desea eliminar la carátula?'
                onClose={ () => setOpenConfirmacionAmparo( false ) }
                onConfirm={ handleEliminarCaratulaAmparo }
            />

        </Layout>
    )
}
